/* global debounce */

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      if (this.form) {
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;

        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        this.form.addEventListener('submit', this.handleSubmit.bind(this));

        if (this.dataset.showQuantitySelector) {
          this.quantitySelector = this.querySelector('quantity-input');

          if (this.quantitySelector) {
            this.quantityInput = this.quantitySelector.querySelector('.qty-input__input');
            this.quantitySelector.addEventListener('change', debounce(this.handleChange.bind(this)));

            this.lineItemChangeListener = this.lineItemChangeListener || this.handleLineItemChange.bind(this);

            document.addEventListener('on:line-item:change', (evt) => {
              this.lineItemChangeListener(evt);
            });
          }
        }

        this.setMaximumInputQuantity();
        this.handleQuantityButtonState();

        document.addEventListener('on:variant:change', this.setMaximumInputQuantity.bind(this));
      }
    }

    disconnectedCallback() {
      document.removeEventListener('on:line-item:change', this.lineItemChangeListener);
    }

    setMaximumInputQuantity() {
      const productInfo = this.closest('.product-info') || this.closest('quick-add-drawer');
      if (!productInfo) return;

      const quantitySelector = this.querySelector('quantity-input');
      if (!quantitySelector) return;

      const quantityInput = quantitySelector.querySelector('.qty-input__input');
      const dataEl = productInfo.querySelector('.js-inventory-data');

      if (dataEl) {
        const variantId = Number(this.form.querySelector('[name="id"]').value);
        const inventoryJson = JSON.parse(dataEl.textContent);
        const inventory = inventoryJson.find((item) => Number(item.id) === variantId);

        if (
          inventory
          && inventory.inventory_management
          && inventory.inventory_management.length !== 0
          && inventory.inventory_quantity > 0
          && inventory.inventory_policy !== 'continue'
        ) {
          quantityInput.max = inventory.inventory_quantity;

          const currentQuantity = Number(quantityInput.value);
          if (currentQuantity > 1 && currentQuantity > inventory.inventory_quantity) {
            quantityInput.value = quantityInput.max;
          }
        } else {
          quantityInput.removeAttribute('max');
        }
      }

      const minusButton = quantitySelector.querySelector('.btn--minus');
      const plusButton = quantitySelector.querySelector('.btn--plus');

      ProductForm.setQuantityButtonState(null, quantityInput, minusButton, plusButton);
    }

    handleQuantityButtonState() {
      const productInfo = this.closest('.product-info') || this.closest('quick-add-drawer');
      if (!productInfo) return;

      const quantitySelector = this.querySelector('quantity-input');
      if (!quantitySelector) return;

      const quantityInput = quantitySelector.querySelector('.qty-input__input');
      const minusButton = quantitySelector.querySelector('.btn--minus');
      const plusButton = quantitySelector.querySelector('.btn--plus');

      plusButton.addEventListener('click', () => {
        ProductForm.setQuantityButtonState('up', quantityInput, minusButton, plusButton);
      });

      minusButton.addEventListener('click', () => {
        ProductForm.setQuantityButtonState('down', quantityInput, minusButton, plusButton);
      });

      ProductForm.setQuantityButtonState(null, quantityInput, minusButton, plusButton);
    }

    static setQuantityButtonState(direction, quantityInput, minusButton, plusButton) {
      const currentQuantity = Number(quantityInput.value);
      const max = Number(quantityInput.max);
      const min = Number(quantityInput.min);

      let newQuantity = currentQuantity;

      if (direction === 'up') {
        newQuantity = currentQuantity + 1;
      } else if (direction === 'down') {
        newQuantity = currentQuantity - 1;
      }

      if (minusButton) minusButton.disabled = newQuantity <= min;
      if (plusButton) plusButton.disabled = max > 0 && newQuantity >= max;
    }

    handleLineItemChange(evt) {
      if (evt.detail.variantId.toString() === this.dataset.variantId) {
        debounce(this.updateQuantityState(evt.detail.newQuantity));
      }
    }

    handleChange(evt) {
      this.updateQuantity(evt.target.value);
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      console.log('GRANDADS PRODUCT FORM SUBMIT RUNNING');

      const variantInput = this.form.querySelector('[name="id"]');
      const quantityInput = this.form.querySelector('[name="quantity"]');

      if (variantInput) {
        variantInput.disabled = false;
        console.log('Submitting variant:', variantInput.value);
      }

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);

        const oldCartData = await oldCartResponse.json();

        /*
          IMPORTANT:
          The original theme request used theme.routes.cartAdd with sections.
          That path returned false sold-out errors for this multi-location single.
          This submits directly to /cart/add.js as JSON.
        */
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity: quantityInput ? Number(quantityInput.value || 1) : 1
          })
        });

        const responseText = await response.text();

        let data;
        try {
          data = JSON.parse(responseText);
        } catch (e) {
          data = {
            status: response.status,
            message: response.status === 429
              ? 'Please wait a few minutes before trying again.'
              : 'Cart request failed. Please refresh and try again.'
          };
        }

        console.log('GRANDADS CART ADD STATUS:', response.status);
        console.log('GRANDADS CART ADD RESPONSE:', data);

        let error = typeof data.description === 'string' ? data.description : data.message;

        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);

        const newCartData = await newCartResponse.json();

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          ProductForm.updateCartIconFromCart(newCartData);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            if (this.cartDrawer) {
              if (
                !quickAddDrawer
                && (
                  (theme.settings.afterAtc === 'drawer_desktop' && theme.mediaMatches.md)
                  || theme.settings.afterAtc === 'drawer'
                )
              ) {
                if (typeof this.cartDrawer.refreshCartDrawer === 'function') {
                  this.cartDrawer.refreshCartDrawer();
                } else {
                  window.location.href = theme.routes.cart;
                }
              } else if (typeof this.cartDrawer.refreshCartDrawer === 'function') {
                this.cartDrawer.refreshCartDrawer();
              }
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');

              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refreshCartItems();
                }
              }
            }
          }, 700);

          const itemInOldCart = oldCartData.items.filter(
            (item) => item.variant_id === data.variant_id
          )[0];

          let newQuantity = 1;

          if (itemInOldCart) {
            newQuantity = (itemInOldCart.quantity === data.quantity)
              ? itemInOldCart.quantity
              : data.quantity;

            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id
              }
            }));

            if (this.quantitySelector) {
              this.setAttribute('data-show-quantity-selector', 'true');
              this.quantityInput.value = newQuantity;
              this.quantitySelector.currentQty = this.quantityInput.dataset.initialValue;
            }
          }
        }
      } catch (error) {
        console.log('GRANDADS CART ADD ERROR:', error);

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg ? this.errorMsg.textContent : error.message
          }
        }));

        if (this.cartDrawer && typeof this.cartDrawer.refreshCartDrawer === 'function') {
          this.cartDrawer.refreshCartDrawer();
        }
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');

        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    static updateCartIconFromCart(cart) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;

      const count = cart.item_count || 0;

      const bubble = cartIconBubble.querySelector(
        '.cart-count-bubble, .cart-icon-bubble__count, [data-cart-count]'
      );

      if (bubble) {
        bubble.textContent = count;
      } else if (count > 0) {
        cartIconBubble.insertAdjacentHTML(
          'beforeend',
          `<div class="cart-count-bubble"><span aria-hidden="true">${count}</span></div>`
        );
      }
    }

    updateQuantityState(newQuantity) {
      this.quantityInput.value = newQuantity;
      this.quantitySelector.currentQty = newQuantity;
      this.setAttribute('data-show-quantity-selector', newQuantity > 0 ? 'true' : 'false');
    }

    async updateQuantity(quantity) {
      this.quantitySelector.setAttribute('aria-disabled', 'true');

      const lineErrors = this.querySelector('.js-product-form-errors');

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      fetchRequestOpts.body = JSON.stringify({
        id: this.dataset.variantId,
        quantity
      });

      try {
        const response = await fetch(theme.routes.cartChange, fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        if (lineErrors) {
          lineErrors.innerHTML = '';
          lineErrors.hidden = true;
        }
      } catch (error) {
        if (lineErrors) {
          if (/^[0-9]+$/.test(error.message)) {
            lineErrors.textContent = theme.strings.cartError;
          } else {
            lineErrors.textContent = error.message;
          }

          lineErrors.hidden = false;
        }

        console.log(error);

        const oldQuantity = parseInt(this.quantityInput.dataset.initialValue, 10);
        this.updateQuantityState(oldQuantity);
      } finally {
        this.updateQuantityState(parseInt(quantity, 10));
        this.quantitySelector.removeAttribute('aria-disabled');

        if (this.cartDrawer && typeof this.cartDrawer.refreshCartDrawer === 'function') {
          this.cartDrawer.refreshCartDrawer();
        }
      }
    }

    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;

      if (error) {
        this.errorMsg.innerHTML = '';

        const errorArray = Array.isArray(error) ? error : [error];

        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}